/* eslint-disable react/jsx-indent */
import React, { useEffect, useContext } from 'react';
import { withRouter } from 'react-router-dom';
import _, { get, isUndefined } from 'lodash';
import { connect } from 'react-redux';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import PropTypes from 'prop-types';
import { getJson } from 'session';
import moment from 'moment';
import { Acl } from 'modules/common/components/Acl';
import ConfirmLabTest from 'modules/common/components/ConfirmLabTest';
import ConfirmAlert from 'modules/common/components/ConfirmAlert';
import { ModalContext } from 'App';
import BusinessEstablishmentList from './BusinessEstablishmentList';
import PrintOccupationalPermitModal from './PrintOccupationalPermitModal';
import PrintHealthCertificateModal from './PrintHealthCertificateModal';
import EditBusinessEstablishmentModal from '../components/EditBusinessEstablishmentModal';
import AddBusinessEstablishmentModal from '../components/AddBusinessEstablishmentModal';
import RePrintHealthCert from './RePrintHealthCert';
import ChangeColorModal from './ChangeColorModal';
import UpdateModal from '../components/UpdateModal';

import VerifyReceipt from '../components/VerifyReceipt';
import * as action from '../action';
import * as c from '../constant';
import UpdateAppointmentModal from '../components/UpdateAppointmentModal';
import ViewOR from '../components/ViewOR';
import Requirements from '../components/Requirements';
import TransactionInformation, {
  RowContent,
} from '../components/TransactionInformation';

const natureOfWorkOption = [
  { label: 'White Card (Food Handlers)', value: 'WHITE_CARD' },
  { label: 'Green Card (Non-food Handler)', value: 'GREEN_CARD' },
  {
    label: 'Pink Card (Entertainment Establishment Workers)',
    value: 'PINK_CARD',
  },
];

function PermitContent({
  transactionInfo,
  showTransaction,
  clearTransaction,
  startAssessment,
  isLoading,
  match,
  onApprove,
  onReject,
  taxpayer,
  settings,
  getSettings,
  updatedHealthStatus,
  taxpayerProfile,
  onPrinted,
  onReceived,
  removeBusinessEst,
  permissions,
  rollback,
  refreshList,
  cancelTransaction,
  getTransactionList,
  filter,
}) {
  const setModal = useContext(ModalContext);
  const selectedTransaction = match.params.id;

  const onPassTest = (key, label) => (e) => {
    e.preventDefault();
    e.stopPropagation();
    ConfirmLabTest(
      `Are you sure, do you want to mark ${label} as passed?`,
      (remarks) => {
        updatedHealthStatus(
          _.get(transactionInfo, 'relationships.module.data.id'),
          {
            [`passed_${key.replace('_amount', '')}`]: 1,
            [`${key.replace('_amount', '')}_findings`]: remarks,
          },
          () => {
            showTransaction(selectedTransaction);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true,
      label
    );
  };

  const onFailTest = (key, label) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want to mark ${label} as failed?`,
      (remarks) => {
        updatedHealthStatus(
          _.get(transactionInfo, 'relationships.module.data.id'),
          {
            [`passed_${key.replace('_amount', '')}`]: 0,
            [`${key.replace('_amount', '')}_findings`]: remarks,
          },
          () => {
            showTransaction(selectedTransaction);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const onRejectTest = (key, label) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want to mark ${label} as rejected?`,
      (remarks) => {
        updatedHealthStatus(
          _.get(transactionInfo, 'relationships.module.data.id'),
          {
            [`${key.replace('_amount', '')}_reject_remarks`]: remarks,
          },
          () => {
            showTransaction(selectedTransaction);
          }
        );
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  const onStartAssessment = () => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, do you want start assessment?`,
      () => {
        startAssessment(selectedTransaction, () => {
          showTransaction(selectedTransaction);
          refreshList(get(selectedTransaction, 'id'));
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const updateData = () => {
    showTransaction(selectedTransaction);
  };

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
    return () => {
      clearTransaction();
    };
  }, []);

  useEffect(() => {
    if (!_.isEmpty(selectedTransaction)) {
      updateData();
    }
  }, [selectedTransaction]);

  const getInitials = (cString) => {
    if (cString) {
      const val = cString.replace(/\[^a-zA-Z- ]/g, '').match(/\b(\w)/g);
      const strFirstTwo = val.slice(0, 2);
      const final = strFirstTwo.join('');
      return final.toUpperCase();
    }
    return null;
  };

  const getNatureOfWork = () => {
    return (
      natureOfWorkOption.find(
        (item) => item.value === _.get(taxpayer, 'nature_of_work')
      ) || {}
    );
  };

  const computeTotalAmount = () => {
    let total = 0;
    if (_.get(taxpayer, 'nature_of_work')) {
      if (_.get(transactionInfo, 'attributes.transaction_type') === 'NEW') {
        if (
          _.get(
            transactionInfo,
            'included.module.attributes.bpls_application_id'
          ) === null
        ) {
          Object.entries(c.DEPENDENCIES)
            .filter((dep) => !!_.get(settings, `attributes.${dep[0]}`))
            .forEach((dep) => {
              total += _.get(settings, `attributes.${dep[0]}`);
            });
        } else {
          Object.entries(c.DEPENDENCIES)
            .filter((dep) => !!_.get(settings, `attributes.${dep[0]}`))
            .map((dep) => {
              // eslint-disable-next-line no-unused-expressions
              ['Health Certificate', 'Occupational Permit'].indexOf(
                dep[1].label
              ) > -1
                ? (total += 0)
                : (total += _.get(settings, `attributes.${dep[0]}`));
              return total;
            });
        }
      }
      if (
        _.get(transactionInfo, 'attributes.transaction_type') ===
        'EDUCATIONAL INSTITUTION'
      ) {
        const healthCertAmount = parseFloat(
          _.get(taxpayer, 'health_certificate_amount') || '0.00'
        );
        const occupationalPermitAmount = parseFloat(
          _.get(taxpayer, 'occupational_permit_amount') || '0.00'
        );
        const stoolAmount = parseFloat(
          _.get(taxpayer, 'stool_amount') || '0.00'
        );
        const drugTestAmount = parseFloat(
          _.get(taxpayer, 'drug_test_amount') || '0.00'
        );
        const xrayAmount = parseFloat(_.get(taxpayer, 'xray_amount') || '0.00');
        total =
          healthCertAmount +
          occupationalPermitAmount +
          stoolAmount +
          drugTestAmount +
          xrayAmount;
      }
    }
    return total;
  };

  useEffect(() => {
    if (_.get(taxpayer, 'nature_of_work'))
      getSettings(_.get(taxpayer, 'nature_of_work'));
  }, [_.get(taxpayer, 'nature_of_work')]);

  const onPrintOccupationalPermit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PrintOccupationalPermitModal data={data} id={data.id} />,
      title: 'Print Occupational Permit',
      modalSize: 'modal-md',
    });
  };

  const handleChangeColor = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <ChangeColorModal data={data} id={data.id} />,
      title: 'Change Card Color',
      modalSize: 'modal-md',
    });
  };

  const updateAppointment = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateAppointmentModal
          data={data}
          id={_.get(data, 'attributes.module_id')}
          selectedTransaction={selectedTransaction}
        />
      ),
      title: 'Update Appointment',
      modalSize: 'modal-xxl',
    });
  };

  const onRegenerateHealthCert = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <RePrintHealthCert data={data} id={data.id} />,
      title: 'Re-generate Occupational Permit',
      modalSize: 'modal-md',
    });
  };

  const onPrintHealthCertificate = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <PrintHealthCertificateModal data={data} id={data.id} />,
      title: 'Print Health Certificate',
      modalSize: 'modal-md',
    });
  };

  const handleOnOpenBusinessActivityModal = (item, type) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <EditBusinessEstablishmentModal info={item} type={type} />,
      title: 'Edit Business Activiy',
      modalSize: 'modal-md',
    });
  };
  const handleAddBusinessEstablishments = (e, item) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <AddBusinessEstablishmentModal transactionId={item} />,
      title: 'Add Business Activity',
      modalSize: 'modal-md',
    });
  };

  const handleOnDeleteBusinessActivity = (item) => (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure, you want to delete this business activity?`,
      () => {
        removeBusinessEst(selectedTransaction, item, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const checkAllFindingsIfPassed = () => {
    return Object.entries(c.DEPENDENCIES)
      .filter((dep) => !!_.get(settings, `attributes.${dep[0]}`))
      .concat([['xray_amount', { label: 'X-Ray' }]])
      .every((dep) => {
        if (+_.get(taxpayer, `passed_${dep[0].replace('_amount', '')}`) === 0) {
          return false;
        }
        return true;
      });
  };

  const showVerifyReceipt = (status) => {
    return [
      'WAITING FOR PAYMENT',
      'PAID',
      'APPROVED',
      'PENDING',
      'EXPIRED REFERENCE NUMBER',
    ].includes(status);
  };

  const handleVerifyReceipt = (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <VerifyReceipt
          transactionInfo={transactionInfo}
          id={selectedTransaction}
        />
      ),
      title: `Assess Payment Receipt`,
      modalSize: 'modal-md',
    });
  };

  const handleEdit = (data) => (e) => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: (
        <UpdateModal
          updateList={data.included.module.attributes}
          updateBusiness={data.included.businessEstablishments}
          id={data.id}
          moduleId={data.attributes.module_id}
        />
      ),
      title: `Update Data Information`,
      modalSize: 'modal-lg',
    });
  };

  const onViewOr = (e) => {
    e.preventDefault();

    setModal({
      isOpen: true,
      content: <ViewOR id={selectedTransaction} />,
      title: `View OR`,
      modalSize: 'modal-lg',
    });
  };

  const onRollback = (item) => (e) => {
    const args = {
      refno: _.get(item, 'attributes.refno'),
    };

    e.preventDefault();
    ConfirmAlert(
      `Are you sure, you want to rollback this application?`,
      () => {
        rollback(args, () => {
          showTransaction(selectedTransaction);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      }
    );
  };

  const onCancelTransaction = (e) => {
    e.preventDefault();
    ConfirmAlert(
      `Are you sure you want to cancel this application?`,
      (remarks) => {
        cancelTransaction(selectedTransaction, { remarks }, () => {
          getTransactionList(filter);
        });
      },
      () => {},
      {
        yesLabel: 'Confirm',
        noLabel: 'Cancel',
      },
      true
    );
  };

  return (
    <>
      <div className="card-section-content container-fluid">
        {isLoading && (
          <div className="loading">
            <div className="spinner text-center">
              <span className="fas fa-1x fa-spin fa-spinner" />
            </div>
          </div>
        )}
        <div className="right-section-content">
          {/* GRAY HIGHLIGHT */}
          <div className="row highlight d-flex align-items-center mx-3 py-3">
            <div className="col-12 px-0 mt-0 mb-1">
              {/* BORDER */}
              <div className="card border-primary">
                <div className="container-fluid py-1">
                  <div className="p-0 d-flex flex-nowrap mb-3 w-100">
                    <div className="d-flex round-image justify-content-center">
                      <h3 className="d-flex align-items-center initials mb-0">
                        {_.get(taxpayerProfile, 'photo') !==
                        '-/format/jpeg/' ? (
                          <img
                            alt="Client Profile"
                            src={_.get(taxpayerProfile, 'photo')}
                          />
                        ) : (
                          getInitials(
                            `${_.get(taxpayer, 'first_name')} ${_.get(
                              taxpayer,
                              'middle_name'
                            )} ${_.get(taxpayer, 'last_name')}`
                          )
                        )}
                      </h3>
                    </div>
                    <div className="d-flex ml-4 align-items-center">
                      <h1 className="transaction-company m-0">
                        {`${_.get(taxpayer, 'first_name') || '-'} ${
                          _.get(taxpayer, 'middle_name') || ''
                        } ${_.get(taxpayer, 'last_name') || ''} ${
                          _.get(taxpayer, 'extension_name') || ''
                        }`}
                      </h1>
                    </div>
                  </div>
                  <div className="row justify-content-end text-right">
                    <div className="col-12">
                      {/* Transaction type: New */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'NEW' &&
                        _.get(taxpayer, 'certificate_number') &&
                        ['APPROVED'].indexOf(
                          _.get(
                            transactionInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 &&
                        Acl(permissions, ['PRINT OCCUPATIONAL PERMIT']) &&
                        !_.get(taxpayer, 'permit_number') && (
                          <button
                            type="button"
                            onClick={onPrintOccupationalPermit(transactionInfo)}
                            className="btn btn-primary font-weight-bold mx-2 mb-2"
                          >
                            PRINT OCCUPATIONAL PERMIT{' '}
                            <i className="fas fa-print" />
                          </button>
                        )}
                      {/* Transaction type: Educational Institution */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'EDUCATIONAL INSTITUTION' &&
                        _.get(taxpayer, 'certificate_number') &&
                        ['PAID'].indexOf(
                          _.get(
                            transactionInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 &&
                        Acl(permissions, ['PRINT OCCUPATIONAL PERMIT']) &&
                        !_.get(taxpayer, 'permit_number') && (
                          <button
                            type="button"
                            onClick={onPrintOccupationalPermit(transactionInfo)}
                            className="btn btn-primary font-weight-bold mx-2 mb-2"
                          >
                            PRINT OCCUPATIONAL PERMIT{' '}
                            <i className="fas fa-print" />
                          </button>
                        )}
                      {/* Transaction type: New */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'NEW' &&
                        !_.get(taxpayer, 'certificate_number') &&
                        ['APPROVED'].indexOf(
                          _.get(
                            transactionInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 &&
                        Acl(permissions, ['PRINT HEALTH CERTIFICATE']) && (
                          <button
                            type="button"
                            onClick={onPrintHealthCertificate(transactionInfo)}
                            className="btn btn-primary font-weight-bold mx-2 mb-2"
                          >
                            PRINT HEALTH CERTIFICATE
                            <i className="fas fa-print" />
                          </button>
                        )}
                      {/* Transaction type: Educational Institution */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'EDUCATIONAL INSTITUTION' &&
                        !_.get(taxpayer, 'certificate_number') &&
                        ['PAID'].indexOf(
                          _.get(
                            transactionInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 &&
                        Acl(permissions, ['PRINT HEALTH CERTIFICATE']) && (
                          <button
                            type="button"
                            onClick={onPrintHealthCertificate(transactionInfo)}
                            className="btn btn-primary font-weight-bold mx-2 mb-2"
                          >
                            PRINT HEALTH CERTIFICATE
                            <i className="fas fa-print" />
                          </button>
                        )}
                      {_.get(transactionInfo, 'attributes.paid_at') &&
                        Acl(permissions, ['OHP VIEW E-OR']) && (
                          <button
                            onClick={onViewOr}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                          >
                            View OR
                          </button>
                        )}
                    </div>
                    <div className="col-12">
                      {showVerifyReceipt(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) && (
                        <button
                          onClick={handleVerifyReceipt}
                          className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                          type="button"
                        >
                          Assess Payment Receipt
                        </button>
                      )}
                      {/* Transaction type: NEW */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'NEW' &&
                        ['PAID', 'PENDING LAB TEST'].indexOf(
                          _.get(
                            transactionInfo,
                            'attributes.transaction_status'
                          )
                        ) > -1 &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        Acl(permissions, ['START ASSESSMENT OHP']) && (
                          <button
                            disabled={isLoading}
                            type="button"
                            onClick={onStartAssessment(transactionInfo)}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                          >
                            {isLoading ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                Start Assessment &nbsp;&nbsp;
                                <i className="fas fa-check" />
                              </>
                            )}
                          </button>
                        )}
                      {/* Transaction type: EDUCATIONAL INSTITUTION */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'EDUCATIONAL INSTITUTION' &&
                        _.get(
                          transactionInfo,
                          'attributes.transaction_status'
                        ) === 'FOR CHECKING' &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 0 &&
                        Acl(permissions, ['START ASSESSMENT OHP']) && (
                          <button
                            disabled={isLoading}
                            type="button"
                            onClick={onStartAssessment(transactionInfo)}
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                          >
                            {isLoading ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                Start Assessment &nbsp;&nbsp;
                                <i className="fas fa-check" />
                              </>
                            )}
                          </button>
                        )}
                      {checkAllFindingsIfPassed() &&
                        +_.get(
                          transactionInfo,
                          'attributes.is_start_assessment'
                        ) === 1 &&
                        Acl(permissions, ['APPROVE OHP']) && (
                          <button
                            type="button"
                            onClick={onApprove(transactionInfo)}
                            className="btn btn-success font-weight-bold mx-2 mb-2"
                            style={{
                              backgroundColor: '#54D468',
                              borderColor: '#54D468',
                            }}
                          >
                            {isLoading ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                Approve <i className="fas fa-check ml-1" />
                              </>
                            )}
                          </button>
                        )}
                      {+_.get(
                        transactionInfo,
                        'attributes.is_start_assessment'
                      ) === 1 &&
                        Acl(permissions, ['REJECT OHP']) && (
                          <button
                            type="button"
                            onClick={onReject(transactionInfo)}
                            className="btn btn-danger font-weight-bold mx-2 mb-2"
                          >
                            {isLoading ? (
                              <i className="fa fa-spin fa-spinner" />
                            ) : (
                              <>
                                Reject <i className="fas fa-times ml-1" />
                              </>
                            )}
                          </button>
                        )}
                      {/* Transaction Type: NEW  */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'NEW' &&
                      _.get(
                        transactionInfo,
                        'attributes.transaction_status'
                      ) === 'APPROVED' &&
                      _.get(taxpayer, 'permit_number') &&
                      _.get(taxpayer, 'certificate_number')
                        ? Acl(permissions, ['TAG AS PRINTED OHP']) && (
                            <button
                              disabled={isLoading}
                              type="button"
                              onClick={onPrinted(transactionInfo)}
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                            >
                              {isLoading ? (
                                <i className="fa fa-spin fa-spinner" />
                              ) : (
                                <>
                                  Tag as Printed &nbsp;&nbsp;
                                  <i className="fas fa-check" />
                                </>
                              )}
                            </button>
                          )
                        : ''}
                      {/* Transaction Type: EDUCATIONAL INSTITUTION */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'EDUCATIONAL INSTITUTION' &&
                      _.get(
                        transactionInfo,
                        'attributes.transaction_status'
                      ) === 'PAID' &&
                      _.get(taxpayer, 'permit_number') &&
                      _.get(taxpayer, 'certificate_number')
                        ? Acl(permissions, ['TAG AS PRINTED OHP']) && (
                            <button
                              disabled={isLoading}
                              type="button"
                              onClick={onPrinted(transactionInfo)}
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                            >
                              {isLoading ? (
                                <i className="fa fa-spin fa-spinner" />
                              ) : (
                                <>
                                  Tag as Printed &nbsp;&nbsp;
                                  <i className="fas fa-check" />
                                </>
                              )}
                            </button>
                          )
                        : ''}
                      {['PRINTED'].indexOf(
                        _.get(transactionInfo, 'attributes.transaction_status')
                      ) > -1
                        ? Acl(permissions, ['TAG AS RECEIVED OHP']) && (
                            <button
                              disabled={isLoading}
                              type="button"
                              onClick={onReceived(transactionInfo)}
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                            >
                              {isLoading ? (
                                <i className="fa fa-spin fa-spinner" />
                              ) : (
                                <>
                                  Tag as Received &nbsp;&nbsp;
                                  <i className="fas fa-check" />
                                </>
                              )}
                            </button>
                          )
                        : ''}
                      {_.get(taxpayer, 'certificate_number') &&
                        Acl(permissions, ['PRINT HEALTH CERTIFICATE']) && (
                          <button
                            onClick={onRegenerateHealthCert(transactionInfo)}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                          >
                            Re-Generate Health Certificate
                          </button>
                        )}
                      {/* Transaction type: NEW */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'NEW' &&
                        ['PAID', 'PENDING'].indexOf(
                          _.get(transactionInfo, 'attributes.status')
                        ) > -1 &&
                        Acl(permissions, ['SPECIAL EDIT OHP APPOINTMENT']) && (
                          <button
                            onClick={updateAppointment(transactionInfo)}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                          >
                            Update Appointment Date
                          </button>
                        )}
                      {/* Transaction type: Educational Institution */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'EDUCATIONAL INSTITUTION' &&
                        Acl(permissions, ['SPECIAL EDIT OHP APPOINTMENT']) && (
                          <button
                            onClick={updateAppointment(transactionInfo)}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold mx-2 mb-2"
                          >
                            Update Appointment Date
                          </button>
                        )}
                      {/* Transaction type: NEW */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'NEW' &&
                        _.get(
                          transactionInfo,
                          'attributes.transaction_status'
                        ) !== 'PAID' &&
                        _.get(transactionInfo, 'attributes.paid_at') &&
                        Acl(permissions, ['OHP ROLLBACK']) && (
                          <button
                            onClick={onRollback(transactionInfo)}
                            type="button"
                            className="btn btn-primary cms-bg-color-primary cms-outline-primary font-weight-bold mx-2 mb-2"
                          >
                            Rollback
                          </button>
                        )}
                      {/* Transaction type: EDUCATIONAL INSTITUTION */}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'EDUCATIONAL INSTITUTION' &&
                        _.get(
                          transactionInfo,
                          'attributes.transaction_status'
                        ) === 'PENDING LAB TEST' &&
                        Acl(permissions, [
                          'OHP - EDUC - DELETE TRANSACTION',
                        ]) && (
                          <button
                            onClick={onCancelTransaction}
                            type="button"
                            className="btn btn-danger font-weight-bold mx-2 mb-2"
                          >
                            <i className="fas fa-times mr-2" />
                            <span>Cancel Application</span>
                          </button>
                        )}
                    </div>
                  </div>
                  <Tabs>
                    <TabList>
                      <Tab>Transaction</Tab>
                      <Tab>Information</Tab>
                      <Tab>Findings</Tab>
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'NEW' &&
                        _.get(transactionInfo, 'included.requirementFiles') &&
                        _.get(transactionInfo, 'included.requirementFiles')
                          .length > 0 && (
                          <>
                            <Tab>Requirements</Tab>
                          </>
                        )}
                      {_.get(transactionInfo, 'attributes.transaction_type') ===
                        'EDUCATIONAL INSTITUTION' && (
                        <>
                          <Tab>Requirements</Tab>
                        </>
                      )}
                    </TabList>
                    <TabPanel>
                      <TransactionInformation
                        module="ohp"
                        transactionInfo={transactionInfo}
                        taxpayer={taxpayer}
                      />
                    </TabPanel>
                    <TabPanel>
                      <div className="p-3 mx-3">
                        {Acl(permissions, ['EDIT OHP']) && (
                          <div className="d-flex justify-content-end mb-4">
                            <button
                              disabled={isLoading}
                              type="button"
                              onClick={handleEdit(transactionInfo)}
                              className="btn btn-primary cms-bg-color-primary cms-outline-primary  font-weight-bold"
                            >
                              {isLoading ? (
                                <i className="fa fa-spin fa-spinner" />
                              ) : (
                                <>Edit Information</>
                              )}
                            </button>
                          </div>
                        )}
                        <div className="alternate-bg-wrapper">
                          <RowContent
                            label="Last Name"
                            value={(
                              _.get(taxpayer, 'last_name') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Middle Name"
                            value={(
                              _.get(taxpayer, 'middle_name') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="First Name"
                            value={(
                              _.get(taxpayer, 'first_name') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Extension Name"
                            value={(
                              _.get(taxpayer, 'extension_name') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Gender"
                            value={(
                              _.get(taxpayer, 'gender') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Address of applicant"
                            value={`${_.get(taxpayer, 'region_name')} ${_.get(
                              taxpayer,
                              'province_name'
                            )} ${_.get(taxpayer, 'municipality_name')} ${_.get(
                              taxpayer,
                              'barangay_name'
                            )} ${_.get(taxpayer, 'street')}`}
                          />
                          <RowContent
                            label="Telephone No."
                            value={(
                              _.get(taxpayer, 'telephone_number') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Mobile No."
                            value={(
                              _.get(taxpayer, 'mobile_number') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Date of Birth"
                            value={
                              _.get(taxpayer, 'birth_date')
                                ? moment(_.get(taxpayer, 'birth_date')).format(
                                    'MM/DD/YYYY'
                                  )
                                : '-'
                            }
                          />
                          <RowContent
                            label="Place of Birth"
                            value={`${
                              _.get(taxpayer, 'place_of_birth_region_name') ||
                              '-'.toUpperCase()
                            } ${(
                              _.get(taxpayer, 'place_of_birth_province_name') ||
                              '-'
                            ).toUpperCase()} ${(
                              _.get(
                                taxpayer,
                                'place_of_birth_municipality_name'
                              ) || '-'
                            ).toUpperCase()}`}
                          />
                          <RowContent
                            label="Civil Status"
                            value={(
                              _.get(taxpayer, 'civil_status') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Highest educational attainment"
                            value={(
                              _.get(
                                taxpayer,
                                'highest_educational_attainment'
                              ) || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Institution"
                            value={(
                              _.get(taxpayer, 'institution_name') || '-'
                            ).toUpperCase()}
                          />
                          <RowContent
                            label="Nature of Work"
                            value={
                              // eslint-disable-next-line react/jsx-wrap-multilines
                              <>
                                <span>{getNatureOfWork().label || '-'}</span>
                                {_.get(
                                  transactionInfo,
                                  'attributes.transaction_type'
                                ) === 'NEW' &&
                                  Acl(permissions, [
                                    'VIEW OHP CHANGE COLOR',
                                  ]) && (
                                    <button
                                      onClick={handleChangeColor(
                                        transactionInfo
                                      )}
                                      className="btn btn-link btn-sm"
                                      type="button"
                                    >
                                      <span className="text-danger">
                                        (edit)
                                      </span>
                                    </button>
                                  )}
                              </>
                            }
                          />
                          <RowContent
                            label="Work Description"
                            value={(
                              _.get(taxpayer, 'work_description_name') || '-'
                            ).toUpperCase()}
                          />
                        </div>
                        <div>
                          <hr className="cit-hr w-100" />
                        </div>
                        <BusinessEstablishmentList
                          formData={taxpayer}
                          handleOnOpenBusinessActivityModal={
                            handleOnOpenBusinessActivityModal
                          }
                          handleOnDeleteBusinessActivity={
                            handleOnDeleteBusinessActivity
                          }
                          handleAdd={(e) =>
                            handleAddBusinessEstablishments(
                              e,
                              selectedTransaction
                            )
                          }
                        />
                      </div>
                    </TabPanel>
                    <TabPanel>
                      <div className="p-4">
                        <table className="transaction-table table table-striped table-borderless table-sm">
                          <thead>
                            <tr>
                              <th
                                className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                                width="20%"
                              >
                                Description
                              </th>
                              <th
                                className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                                width="40%"
                              >
                                Findings
                              </th>
                              <th
                                className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                                width="30%"
                              >
                                Action
                              </th>
                              <th
                                className="py-3 cms-text-primary cms-bg-color-primary-light font-weight-bold"
                                width="10%"
                              >
                                Amount
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {Object.entries(c.DEPENDENCIES)
                              .filter(
                                (dep) =>
                                  !!_.get(settings, `attributes.${dep[0]}`)
                              )
                              .concat([['xray_amount', { label: 'X-Ray' }]])
                              .map((dep) => {
                                const label = (_.get(dep, '1.label') || '')
                                  .toLowerCase()
                                  .replace(' ', '_')
                                  .replace(' ', '_')
                                  .replace('-', '');
                                const findings = _.get(
                                  taxpayer,
                                  `${label}_findings`
                                );
                                const reject_remarks = _.get(
                                  taxpayer,
                                  `${label}_reject_remarks`
                                );
                                const isPassed = +_.get(
                                  taxpayer,
                                  `passed_${label}`
                                );

                                return (
                                  <>
                                    <tr key={dep[0]} className="text-dark">
                                      <td>{dep[1].label}</td>
                                      <td className="d-flex flex-column text-center">
                                        {typeof isPassed === 'number' &&
                                        !isUndefined(
                                          _.get(taxpayer, `passed_${label}`)
                                        ) &&
                                        isPassed ? (
                                          <span className="text-success">
                                            Passed
                                          </span>
                                        ) : (
                                          <></>
                                        )}
                                        {typeof isPassed === 'number' &&
                                        !isUndefined(
                                          _.get(taxpayer, `passed_${label}`)
                                        ) &&
                                        !isPassed &&
                                        findings ? (
                                          <span className="text-danger">
                                            Failed
                                          </span>
                                        ) : (
                                          <></>
                                        )}
                                        {findings && (
                                          <>
                                            <small>{findings}</small>
                                          </>
                                        )}
                                      </td>
                                      <td>
                                        {+_.get(
                                          transactionInfo,
                                          'attributes.is_start_assessment'
                                        ) === 1 &&
                                          [
                                            'health_certificate_amount',
                                            'occupational_permit_amount',
                                          ].indexOf(dep[0]) < 0 &&
                                          Acl(permissions, [
                                            'HEALTH LAB APPROVALS',
                                          ]) && (
                                            <button
                                              type="button"
                                              onClick={onPassTest(
                                                dep[0],
                                                dep[1].label
                                              )}
                                              className="btn btn-success btn-sm"
                                              style={{
                                                backgroundColor: '#54D468',
                                                borderColor: '#54D468',
                                              }}
                                            >
                                              <i className="fas fa-check" />
                                            </button>
                                          )}
                                        &nbsp;
                                        {+_.get(
                                          transactionInfo,
                                          'attributes.is_start_assessment'
                                        ) === 1 &&
                                          [
                                            'health_certificate_amount',
                                            'occupational_permit_amount',
                                          ].indexOf(dep[0]) < 0 &&
                                          Acl(permissions, [
                                            'HEALTH LAB APPROVALS',
                                          ]) && (
                                            <button
                                              type="button"
                                              onClick={onFailTest(
                                                dep[0],
                                                dep[1].label
                                              )}
                                              className="btn btn-danger btn-sm"
                                            >
                                              <i className="fas fa-times" />
                                            </button>
                                          )}
                                        &nbsp;
                                        {+_.get(
                                          transactionInfo,
                                          'attributes.is_start_assessment'
                                        ) === 1 &&
                                          findings &&
                                          !isPassed &&
                                          [
                                            'health_certificate_amount',
                                            'occupational_permit_amount',
                                          ].indexOf(dep[0]) < 0 &&
                                          dep[0] === 'drug_test_amount' &&
                                          Acl(permissions, [
                                            'HEALTH LAB APPROVALS',
                                          ]) && (
                                            <button
                                              type="button"
                                              onClick={onRejectTest(
                                                dep[0],
                                                dep[1].label
                                              )}
                                              className="btn btn-danger btn-sm font-weight-bold my-1"
                                            >
                                              Reject
                                            </button>
                                          )}
                                      </td>
                                      <td>
                                        {/* Transaction type: New */}
                                        {_.get(
                                          transactionInfo,
                                          'attributes.transaction_type'
                                        ) === 'NEW' && (
                                          <>
                                            <span className="font-weight-bold mr-2">
                                              PHP
                                            </span>
                                            <span>
                                              {[
                                                'Health Certificate',
                                                'Occupational Permit',
                                              ].indexOf(dep[1].label) > -1 &&
                                              _.get(
                                                transactionInfo,
                                                'included.module.attributes.bpls_application_id'
                                              ) !== null
                                                ? '0.00'
                                                : (
                                                    _.get(
                                                      settings,
                                                      `attributes.${dep[0]}`
                                                    ) || '0.00'
                                                  ).toLocaleString(undefined, {
                                                    minimumFractionDigits: 2,
                                                    maximumFractionDigits: 2,
                                                  })}
                                            </span>
                                          </>
                                        )}
                                        {/* Transaction type: Educational Institution */}
                                        {_.get(
                                          transactionInfo,
                                          'attributes.transaction_type'
                                        ) === 'EDUCATIONAL INSTITUTION' && (
                                          <>
                                            <span className="font-weight-bold mr-2">
                                              PHP
                                            </span>
                                            <span>
                                              {(
                                                _.get(taxpayer, dep[0]) ||
                                                '0.00'
                                              ).toLocaleString(undefined, {
                                                minimumFractionDigits: 2,
                                                maximumFractionDigits: 2,
                                              })}
                                            </span>
                                          </>
                                        )}
                                      </td>
                                    </tr>
                                    {reject_remarks && (
                                      <tr
                                        key={`${dep[0]}_rejected`}
                                        className="text-dark"
                                      >
                                        <td />
                                        <td className="d-flex flex-column text-center">
                                          <span className="text-danger">
                                            Rejected
                                          </span>
                                          <small>{reject_remarks}</small>
                                        </td>
                                        <td />
                                        <td />
                                      </tr>
                                    )}
                                  </>
                                );
                              })}
                            <tr className="text-dark">
                              <td />
                              <td />
                              <td>Total</td>
                              <td>
                                <span className="font-weight-bold mr-2">
                                  PHP
                                </span>
                                <span>
                                  {computeTotalAmount().toLocaleString(
                                    undefined,
                                    {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    }
                                  )}
                                </span>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </TabPanel>
                    {_.get(transactionInfo, 'attributes.transaction_type') ===
                      'NEW' &&
                      _.get(transactionInfo, 'included.requirementFiles') &&
                      _.get(transactionInfo, 'included.requirementFiles')
                        .length > 0 && (
                        <TabPanel>
                          <Requirements
                            data={_.get(
                              transactionInfo,
                              'included.requirementFiles'
                            )}
                          />
                        </TabPanel>
                      )}
                    {_.get(transactionInfo, 'attributes.transaction_type') ===
                      'EDUCATIONAL INSTITUTION' && (
                      <TabPanel>
                        <Requirements
                          businessRequirements={
                            _.get(
                              transactionInfo,
                              'included.requirementFiles'
                            ) &&
                            _.get(transactionInfo, 'included.requirementFiles')
                              .length > 0
                              ? _.get(
                                  transactionInfo,
                                  'included.requirementFiles'
                                )
                              : false
                          }
                          laboratoryRequirements={
                            _.get(transactionInfo, 'included.laboratories') ??
                            false
                          }
                        />
                      </TabPanel>
                    )}
                  </Tabs>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

PermitContent.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  taxpayer: PropTypes.instanceOf(Object).isRequired,
  showTransaction: PropTypes.instanceOf(Function).isRequired,
  removeBusinessEst: PropTypes.instanceOf(Function).isRequired,
  transactionInfo: PropTypes.instanceOf(Object).isRequired,
  clearTransaction: PropTypes.instanceOf(Function).isRequired,
  startAssessment: PropTypes.instanceOf(Function).isRequired,
  onApprove: PropTypes.instanceOf(Function).isRequired,
  onReject: PropTypes.instanceOf(Function).isRequired,
  isLoading: PropTypes.bool.isRequired,
  settings: PropTypes.instanceOf(Object).isRequired,
  getSettings: PropTypes.instanceOf(Function).isRequired,
  updatedHealthStatus: PropTypes.instanceOf(Function).isRequired,
  taxpayerProfile: PropTypes.instanceOf(Object).isRequired,
  onPrinted: PropTypes.instanceOf(Object).isRequired,
  onReceived: PropTypes.instanceOf(Object).isRequired,
  permissions: PropTypes.instanceOf(Object).isRequired,
  rollback: PropTypes.instanceOf(Function).isRequired,
  refreshList: PropTypes.instanceOf(Function).isRequired,
  cancelTransaction: PropTypes.instanceOf(Function).isRequired,
  getTransactionList: PropTypes.instanceOf(Function).isRequired,
  filter: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  permissions: getJson('permissions'),
  settings: _.get(api, `${c.GET_SETTINGS}.item`) || {},
  transactionInfo: _.get(api, `${c.SHOW_TRANSACTION}.item`) || {},
  taxpayerProfile:
    _.get(api, `${c.SHOW_TRANSACTION}.item.included.taxPayer.attributes`) || {},
  taxpayer:
    {
      ...(_.get(api, `${c.SHOW_TRANSACTION}.item.included.module.attributes`) ||
        {}),
      business_establishments:
        _.get(
          api,
          `${c.SHOW_TRANSACTION}.item.included.businessEstablishments`
        ) || [],
    } || {},
  isLoading:
    api.loading.indexOf(c.SHOW_TRANSACTION) > -1 ||
    api.loading.indexOf(c.APPROVE_TRANSACTION) > -1 ||
    api.loading.indexOf(c.REJECT_TRANSACTION) > -1 ||
    api.loading.indexOf(c.START_ASSESSMENT) > -1 ||
    api.loading.indexOf(c.TAG_AS_PRINTED) > -1 ||
    api.loading.indexOf(c.TAG_AS_RECIVED) > -1 ||
    api.loading.indexOf(c.ROLLBACK) > -1 ||
    api.loading.indexOf(c.CANCEL_TRANSACTION) > -1,
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, action)]);

export default enhance(PermitContent);
